'use client'

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import Image, { StaticImageData } from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import LogoNeo3d from '../../public/images/neo.png'
import LogoOrthodontic from '../../public/images/orthodontics.png'

type LogoProps = {
  href: string
  src: StaticImageData
  alt: string
  width: number
  height: number
}

const Logo = ({ href, src, alt, width, height }: LogoProps) => (
  <div className="grid justify-center items-center">
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <Link href={href} target="_blank" rel="noopener noreferrer" aria-label={alt}>
            <Image
              src={src}
              alt={alt}
              className={`m-auto w-[${width}px] h-[${height}px]`}
              width={width}
              height={height}
              priority
            />
          </Link>
        </TooltipTrigger>
        <TooltipContent side="bottom">{alt}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </div>
)

const logos = [
  {
    href: 'https://www.orthodontie-3d.fr/',
    src: LogoNeo3d,
    alt: "Laboratoire d'orthodontie",
    width: 240,
    height: 67,
  },
  {
    href: 'https://www.labo-orthodontics.fr/',
    src: LogoOrthodontic,
    alt: "Laboratoire Orthodontic's",
    width: 280,
    height: 67,
  },
]

export function Header() {
  const pathname = usePathname()
  const logoClasses = `${pathname !== '/emails' ? '2xl:absolute 2xl:grid-cols-1 2xl:gap-5 2xl:top-0' : 'hidden'}`

  return (
    <header className="static top-0 grid gap-5 justify-center items-center">
      <h1 className="order-first 2xl:order-2 text-xl font-bold flex justify-center gap-2">
        OFFRE DE PARRAINAGE
        {pathname === '/' || pathname === '/form' ? <span>*</span> : null}
      </h1>

      {/* Version mobile/tablette */}
      <div className="grid gap-8 2xl:hidden">
        {logos.map((logo) => (
          <Logo key={logo.href} {...logo} />
        ))}
      </div>

      {/* Version desktop */}
      <div
        className={`hidden 2xl:grid justify-center items-center ${logoClasses} 2xl:-left-1/6 order-1`}
      >
        <Logo {...logos[0]} />
      </div>

      <div
        className={`hidden 2xl:grid justify-center items-center ${logoClasses} 2xl:-right-1/6 order-3`}
      >
        <Logo {...logos[1]} />
      </div>
    </header>
  )
}
